import React, { useState, useEffect } from 'react';
 // Asumiendo que usas React Router
import WhatsAppButton from '../../Molecules/WhatsAppButton/WhatsAppButton';
import {
  useGetComponentParametersSingle,useGetComponentParameters
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import {
  TYPE_FETCH_PARAMETERS
} from '../../../Domain/Settings/Constants/Constants';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import { useCombinedObjects } from '../../../Domain/Utils/ApiUtilies/Parameters/Parameters';

// El componente ahora es más "tonto", solo obedece la prop
const FloatingWhatsApp = ({ isVisible }) => {
  const parametersMlt = useGetComponentParametersSingle(
    COMPONENTS.WHATSAPP_BUTTON,
    TYPE_FETCH_PARAMETERS.STANDARD
  );
  const parametersFormMlt = useGetComponentParameters(COMPONENTS.WHATSAPP_BUTTON);
  const parameters = useCombinedObjects(parametersMlt, parametersFormMlt);
  const [phoneNumber, setPhoneNumber] = useState(null);

  useEffect(() => {
    // Se ejecuta si el botón debe ser visible y si ya tenemos los parámetros.
    if (isVisible && parameters) {
      const getNumber = () => { // Ya no necesita ser async aquí
        const number = parameters?.FIL_WHATSAPP?.value;
        setPhoneNumber(number);
      };
      getNumber();
    }
  }, [isVisible, parameters]); // ✅ CAMBIO CLAVE: AÑADIMOS 'parameters' A LAS DEPENDENCIAS

  // Si no es visible o aún no tenemos el número, no renderizamos nada.
  if (!isVisible || !phoneNumber) {
    return null;
  }
  
  const welcomeMessage = parameters?.MESSAGE_WHATAPP?.value;

  return <WhatsAppButton
    phoneNumber={phoneNumber}
    message={welcomeMessage}
  />;
};

export default FloatingWhatsApp;